import { api } from "@/lib/api";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "@tanstack/react-router";
import { HubApps } from "./integrations/HubApps";
import { containerPermissions } from "@/lib/boo-permissions";

// The Boo-scoped integrations hub: connected accounts plus the full catalog
// browser (category rail + search). What boo-backend connects itself (chat
// apps, code hosts, Microsoft 365) lives on the Connections tab; installable
// apps (bundles) on the Apps tab. Connectors Boo built are under Custom in
// the hub's rail.
export function IntegrationsTab() {
  const params = useParams({ strict: false }) as { containerId?: string };
  const containerId = params.containerId!;

  const { data: listResponse } = useQuery({
    queryKey: ["containers"],
    queryFn: api.containers.list,
  });
  const container = listResponse?.data.find((c) => c.id === containerId);
  const permissions = containerPermissions(container, listResponse?._permissions);

  if (!container) return null;

  return (
    <div className="flex flex-1 flex-col min-h-0 overflow-auto p-6 gap-8">
      <HubApps containerId={container.id} permissions={permissions} />
    </div>
  );
}
